module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_m_albino.9a9b08a8.png";